import React from 'react';
import { ApIcon } from '@alixpartners/ui-components';
import {
  Overlay,
  ModalBox,
  ModalHeader,
  ModalTitle,
  CloseButton,
  ModalBody,
  ModalFooter,
  CancelBtn,
  DeleteBtn,
} from './MappingCancelDialog.styles';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onCancel: () => void;
}

export const MappingCancelDialog: React.FC<IProps> = ({
  isOpen,
  onClose,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <Overlay onClick={onClose}>
      <ModalBox onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>Delete ongoing mapping session?</ModalTitle>
          <CloseButton onClick={onClose}>
            <ApIcon iconName="close" iconSize={24} iconColor="#4a4a4a" />
          </CloseButton>
        </ModalHeader>
        <ModalBody>
          This action will permanently remove the mapping session, all mapped
          data, and any uploaded files. This action cannot be undone.
        </ModalBody>
        <ModalFooter>
          <CancelBtn onClick={onClose}>Cancel</CancelBtn>
          <DeleteBtn onClick={onCancel}>Delete</DeleteBtn>
        </ModalFooter>
      </ModalBox>
    </Overlay>
  );
};
